<template>
  <div>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div class="">
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Intellectual Property
          </h2>
        </div>
      </div>
    </div>
    <div class="menucontrol-scroll fixed-top py-8 px-8">
      <div class="grid grid-cols-3 gap-8">
        <div class="elshadow rounded-lg p-4 bg-white">
          <h4 class="fsize16 mb-4">Intellectual Property</h4>
          <el-switch
            class="mb-4"
            v-model="value"
            active-color="#cd3197"
            inactive-color="#b8c2cc"
          >
          </el-switch>
        </div>
        <div class="elshadow rounded-lg bg-white p-4">
          <h4 class="fsize16 mb-4">Update powered by BRAINED</h4>
          <el-switch
            class="mb-4"
            v-model="value2"
            active-color="#cd3197"
            inactive-color="#b8c2cc"
          >
          </el-switch>
        </div>
        <div class="elshadow rounded-lg p-4 bg-white">
          <div class="flex">
            <h4 class="fsize16 mb-4">Whatsapp</h4>
            <feather-icon
              @click="openWhatsapp()"
              icon="ExternalLinkIcon"
              class="textff9493 flex ml-2"
              svgClasses="w-5 h-5 cursor-pointer"
            />
          </div>

          <el-switch
            class="mb-4"
            v-model="value3"
            active-color="#cd3197"
            inactive-color="#b8c2cc"
          >
          </el-switch>

          <div v-if="isShowWhatsapp">
            <vue-tel-input
              :disabled="this.isEdit"
              :disabledFormatting="true"
              :enabledCountryCode="true"
              placeholder="Enter phone no"
              name="Mobile number"
              :required="true"
              v-validate="'required|numeric'"
              defaultCountry="IN"
              :autoDefaultCountry="true"
              v-model="number"
              class="w-full mt-2 h-12 rounded-xl div-autowidth"
              @country-changed="getCountry"
            ></vue-tel-input>
            <p v-if="errors.has('Mobile number')" class="text-danger">
              {{ errors.first("Mobile number") }}
            </p>
            <div class="mt-10 flex justify-center gap-4">
              <vs-button
                variant="primary"
                v-if="this.isEdit"
                @click="editable()"
                class="rounded-full border-0 text-white font-semibold lg:py-3 md:py-3 py-2 px-8 sm-fsize14"
              >
                Edit
              </vs-button>
              <vs-button
                v-else
                variant="primary"
                @click="shareOnWhatsapp()"
                class="rounded-full border-0 text-white font-semibold lg:py-3 md:py-3 py-2 px-8 sm-fsize14"
              >
                Continue
              </vs-button>

              <!-- <vs-button
                color="secondary"
                @click="resetAll()"
                class="rounded-full bg-secondary border-0 text-white font-semibold lg:py-3 md:py-3 py-2 px-8 sm-fsize14"
              >
                Reset
              </vs-button> -->
            </div>
          </div>
        </div>
        <!-- <el-dialog
          title="Share on Whatsapp"
          :visible.sync="dialogVisible"
          width="30%"
        >
          <vue-tel-input
            :disabledFormatting="true"
            :enabledCountryCode="true"
            placeholder="Enter phone no"
            name="Contact no"
            :required="true"
            defaultCountry="IN"
            :autoDefaultCountry="true"
            v-model="number"
            class="w-full mt-2 h-12 rounded-xl div-autowidth"
            v-validate="'required|numeric'"
            data-vv-validate-on="input|blur"
            @country-changed="getCountry"
          ></vue-tel-input>
          <span class="text-danger fsize10">
            {{ errors.first("Contact no") }}
          </span>
          <div class="mt-10 flex justify-center gap-4">
            <vs-button
              variant="primary"
              @click="shareOnWhatsapp()"
              class="rounded-full border-0 text-white font-semibold lg:py-3 md:py-3 py-2 px-8 sm-fsize14"
            >
              Continue
            </vs-button>

            <vs-button
              color="secondary"
              @click="resetAll()"
              class="rounded-full bg-secondary border-0 text-white font-semibold lg:py-3 md:py-3 py-2 px-8 sm-fsize14"
            >
              Reset
            </vs-button> 
          </div>
        </el-dialog> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import axios from "axios";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
export default {
  components: {
    VueTelInput,
  },
  data() {
    return {
      name: "",
      number: "",
      isShowWhatsapp: false,
      email: "",
      code: "",
      iso2: "",
      dialCode: "",

      // dialogVisible: false,
      value: false,
      value2: false,
      value3: false,
      getproject: "",
      isEdit: false,
    };
  },
  methods: {
    toggleval() {
      if (this.toggle === true) {
        this.value = true;
      } else {
        this.value = false;
      }
    },
    async updatePoweredBy(value) {
      let payload = {
        projectId: this.selectedProject._id,
      };
      if (value !== this.getproject.poweredBy) {
        Object.assign(payload, { poweredBy: value });
      }
      let data = await this.$store.dispatch("user/updateProject", payload);
    },
    async updateWhatsappToggle(value) {
      let payload = {
        projectId: this.selectedProject._id,
      };
      if (value !== this.getproject.whatsappToggle) {
        Object.assign(payload, { whatsappToggle: value });
      }
      let data = await this.$store.dispatch("user/updateProject", payload);
      await this.getProjectData();
    },
    async updateIntellectualPropForProject(value) {
      let payload = {
        projectId: this.selectedProject._id,
        intellectualProperty: value,
      };

      let data = await this.$store.dispatch("user/updateProject", payload);
      await this.$store.dispatch("user/getProject", {
        projectId: this.selectedProject._id,
      });
    },
    async getProjectData() {
      let payload = {
        projectName: this.selectedProject.projectName,
      };
      let data = await this.$store.dispatch("user/getProject", payload);
      this.getproject = data;
      this.value2 = this.getproject.poweredBy;
      this.value = this.getproject.hasOwnProperty("intellectualProperty")
        ? this.getproject.intellectualProperty
        : false;
      this.value3 = this.getproject.hasOwnProperty("whatsappToggle")
        ? this.getproject.whatsappToggle
        : false;
      this.number = this.getproject.hasOwnProperty("whatsappNumber")
        ? this.getproject.whatsappNumber.toString()
        : "";
      if (this.getproject.hasOwnProperty("whatsappNumber")) {
        this.isEdit = this.getproject.whatsappNumber ? true : false;
      }
      this.isShowWhatsapp = this.getproject.hasOwnProperty("whatsappToggle")
        ? this.getproject.whatsappToggle
        : false;
    },
    async openWhatsapp() {
      if (this.getproject.hasOwnProperty("whatsappNumber")) {
        await window.open(
          `https://api.whatsapp.com/send/?phone=%2B${this.code.dialCode}${this.getproject.whatsappNumber}&text&type=phone_number&app_absent=0`,
          "_blank"
        );
      } else if (this.number) {
        await window.open(
          `https://api.whatsapp.com/send/?phone=%2B${this.code.dialCode}${this.number}&text&type=phone_number&app_absent=0`,
          "_blank"
        );
      }
    },
    async updateIntellectualProp(value) {
      let payload = {
        projectId: this.selectedProject.projectId,
        projectName: this.selectedProject.projectName,
        toggleValue: value,
      };
      let data = await this.$store.dispatch("modules/update", payload);
      await this.$store.dispatch("modules/getModules", payload);

      // this.getproject = data;
      // this.value2 = this.getproject.poweredBy;
    },
    getCountry(country) {
      this.code = country;
    },
    checkNumber() {
      console.log(this.number, "NUM");
    },
    async shareOnWhatsapp() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          // if (this.getproject.hasOwnProperty("whatsappNumber")) {
          if (this.number !== this.getproject.whatsappNumber) {
            this.$swal({
              text: `Are you sure with mobile number? `,
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Confirm",
              cancelButtonText: "Cancel",
            }).then(async (value) => {
              if (value.isConfirmed == true) {
                if (this.number) {
                  console.log(this.code.dialCode, this.number, "NUMM");
                  let payload = {
                    projectId: this.selectedProject._id,
                    whatsappNumber: this.number,
                  };
                  let data = await this.$store.dispatch(
                    "user/updateProject",
                    payload
                  );
                  await this.getProjectData();
                  await window.open(
                    `https://api.whatsapp.com/send/?phone=%2B${this.code.dialCode}${this.number}&text&type=phone_number&app_absent=0`,
                    "_blank"
                  );
                }
              }
            });
          } else {
            this.$swal({
              title: "Warning!",
              text: `Email Already exists`,
              icon: "warning",
              timer: 5000,
              buttons: false,
            });
          }
          // }
        }
      });
    },
    resetAll() {
      this.$validator.reset();
      // this.number = "";
      // this.code.iso2 = "IN";
      // this.code.dialCode = "91";
    },
    editable() {
      if (this.isEdit === true) {
        this.isEdit = false;
      } else {
        this.isEdit = true;
      }
    },
  },

  computed: {
    ...mapState("IntellectualProperty", ["toggle"]),
    ...mapState("user", ["selectedProject"]),
    ...mapState("modules", ["modulesList"]),
  },
  async mounted() {
    await this.getProjectData();
    this.toggleval();
  },
  watch: {
    async value(oldval, newval) {
      if (newval !== oldval) {
        // this.$store.commit("IntellectualProperty/SET_TOGGLE", oldval);
        await this.updateIntellectualProp(oldval);
        await this.updateIntellectualPropForProject(oldval);
      }
    },
    value2(oldval, newval) {
      if (newval !== oldval) {
        this.updatePoweredBy(oldval);
      }
    },
    value3(oldval, newval) {
      if (newval !== oldval) {
        this.updateWhatsappToggle(oldval);
      }
    },
    code(newVal) {
      console.log(newVal, "newVal");
      // this.checkNumber();
    },
  },
};
</script>
